<template>
    <el-dialog title="您确定要删除吗" :visible.sync="deleteDialogVisible" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <div v-loading="formLoading">
            <p class="dialog-txt-tip">该公海被删除后，公海所有客户将自动转移到所选公海</p>
            <el-form ref="formData" :rules="formDataRules" :model="formData" label-position="top">
                <el-form-item label="选择公海" prop="transfer_seas_id">
                    <el-select ref="userSelect" v-model="formData.transfer_seas_id" placeholder="请选择需要转移到的公海" filterable>
                        <el-option v-for="item in highSeasList" :key="item.id" :label="item.seas_name" :value="item.id" :disabled="item.id == deleteId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { GetHighSeasManagementList, HighSeasManagementDel } from "@/api"
export default {
    name: "HighSeasDelete",
    props: {
        deleteDialogVisible: {
            type: Boolean,
            default: false
        },
        deleteId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            formLoading: true,
            btnDisabled: false,
            formData: {
                transfer_seas_id: "",
            },
            formDataRules: {
                transfer_seas_id: [{ required: true, message: "请选择需要转移到的公海", trigger: "change" }]
            },
            highSeasList: []
        }
    },
    created() {
        this.getHighSeasList()
    },
    methods: {
        getHighSeasList() {
            GetHighSeasManagementList().then(res => {
                if (res.code == 200) {
                    this.highSeasList = res.data || []
                }
            }).finally(() => {
                this.formLoading = false
            })
        },
        handleDialogClose() {
            this.$emit("update:deleteDialogVisible", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    this.btnDisabled = true
                    HighSeasManagementDel(this.deleteId, { transfer_seas_id: this.formData.transfer_seas_id }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.message || "删除成功")
                            this.btnDisabled = false
                            this.$emit("update:deleteDialogVisible", false)
                            this.$emit("handleDelCallback")
                        } else {
                            this.$message.error(res.message)
                            this.btnDisabled = false
                        }
                    })
                }
            })
        }
    }
}
</script>